import { IListElementCell } from 'app/services/api5-service/api.interface';

import { ISPFormState } from 'common/dynamic-form/model';
import { DocHelper } from 'utils/dochelper';

import { IListCellUi } from '../../list-cell/model';

/**
 * Get msg cell with specific data
 *
 * @param baseCell - FE cell base metadata
 * @param state - form state
 * @param cellData - BE meta of cell
 */
export function getMsgCellWithData(
  baseCell: IListCellUi,
  state: ISPFormState,
  cellData: IListElementCell,
): IListCellUi {
  const cellValue = cellData.$;
  const cellMsg = DocHelper.getMessage(cellValue, state.docSubject.value);
  const value = cellMsg || cellValue;

  baseCell.maxWidth = baseCell.ellipsis ? baseCell.width : '600px';
  baseCell.value = value;
  baseCell.trackBy = value;
  return baseCell;
}
